/* ================================
===    ADS                     ====
=================================== */
function setADS(zone,width,height){
  return "<div style=\"padding: 25px 0.5em;background: #000000;border: 1px solid #ebebeb;min-height: "+height+"px;max-width: "+width+"px;width: 100%;display: flex;align-items: center;text-align: center;justify-content: center;margin: auto;\"><span style=\"color: #f5f5f5;text-decoration: none;\">Here you can place <b>"+zone+"</b> banner</span></div>";
}
function theme_ads_medium_rectangle_up($container) {
  console.log('rectangle ');
  console.log($container);
  try {
    if (typeof(googletag) !== "undefined" && googletag) {
      var mapping = googletag.sizeMapping().
      addSize([0, 0],     [300, 250] ).
      addSize([736, 100], [[300, 600], [300, 250]] ).
      build();
      if (!jQuery.isArray(window.theme_www_post_sidebar_infinity)) { window.theme_www_post_sidebar_infinity = []; }
      var id_banner = "div-gpt-ad-" + alphanumeric_unique();
      window.theme_www_post_sidebar_infinity[id_banner] =
        googletag.defineSlot('/7288/thebarba/genr/pn', [[300, 250],[300, 600]], id_banner).
        defineSizeMapping(mapping).
        addService(googletag.pubads()).
        setCollapseEmptyDiv(true);

      $container.html("<div id='" + id_banner + "'>" +
        "<script type='text/javascript'>" +
        "googletag.cmd.push(function() { " +
          "googletag.display('" + id_banner + "'); " +
          "googletag.pubads().refresh([window.theme_www_post_sidebar_infinity['" + id_banner + "']]); " +
        "});" +
        "</script>" +
        "</div>");    
    } else {
      if(isFunction(setADS)) { $container.html(setADS("MEDIUM RECTANGLE UP JS",300,250)); }
    }
  } catch (err)  {
    if(isFunction(setADS)) { $container.html(setADS("MEDIUM RECTANGLE UP JS",300,250)); }
  }
}

function theme_ads_medium_rectangle_dw($container) {
  console.log('rectangle_dw ');
  console.log($container);
  try {
    if (typeof(googletag) !== "undefined" && googletag) {
      var mapping = googletag.sizeMapping().
      addSize([0, 0],     [300, 250] ).
      addSize([736, 100], [[300, 600], [300, 250]] ).
      build();
      if (!jQuery.isArray(window.theme_www_post_sidebar_infinity_dw)) { window.theme_www_post_sidebar_infinity_dw = []; }
      var id_banner = "div-gpt-ad-" + alphanumeric_unique();
      window.theme_www_post_sidebar_infinity_dw[id_banner] =
        googletag.defineSlot('/7288/thebarba/genr_down/pn', [[300, 250],[300, 600]], id_banner).
        defineSizeMapping(mapping).
        addService(googletag.pubads()).
        setCollapseEmptyDiv(true);

      $container.html("<div id='" + id_banner + "'>" +
        "<script type='text/javascript'>" +
        "googletag.cmd.push(function() { " +
          "googletag.display('" + id_banner + "'); " +
          "googletag.pubads().refresh([window.theme_www_post_sidebar_infinity_dw['" + id_banner + "']]); " +
        "});" +
        "</script>" +
        "</div>");
    } else {
      if(isFunction(setADS)) { $container.html(setADS("MEDIUM RECTANGLE DW JS",300,250)); }
    }
  } catch (err)  {
    if(isFunction(setADS)) { $container.html(setADS("MEDIUM RECTANGLE DW JS",300,250)); }
  }
}

function theme_ads_post_header_leaderboard($container) {
  try {
    if (typeof(googletag) !== "undefined" && googletag) {
      var mapping = googletag.sizeMapping().
      addSize([0, 0],   [[320, 100], [320, 50], [300, 50]] ).
      addSize([740, 100], [[728,90], [970, 90], [970, 250], [980, 30], [980, 60], [980, 250]] ).
      build();
      if (!jQuery.isArray(window.theme_www_post_sidebar_infinity_leaderbord)) { window.theme_www_post_sidebar_infinity_leaderbord = []; }
      var id_banner = "div-gpt-ad-" + alphanumeric_unique();
      window.theme_www_post_sidebar_infinity_leaderbord[id_banner] =
        googletag.defineSlot('/7288/thebarba/genr/pn', [[320, 100], [320, 50], [300, 50], [728,90], [970, 90], [970, 250], [980, 30], [980, 60], [980, 250]], id_banner).
        defineSizeMapping(mapping).
        addService(googletag.pubads()).
        setCollapseEmptyDiv(true);

      $container.html("<div id='" + id_banner + "'>" +
        "<script type='text/javascript'>" +
        "googletag.cmd.push(function() { " +
          "googletag.display('" + id_banner + "'); " +
          "googletag.pubads().refresh([window.theme_www_post_sidebar_infinity_leaderbord['" + id_banner + "']]); " +
        "});" +
        "</script>" +
        "</div>");
    } else  {
      if(isFunction(setADS)) { $container.html(setADS("LEADERBOARD JS",728,90)); }
    }
  } catch (err) {
    if(isFunction(setADS)) { $container.html(setADS("LEADERBOARD JS",728,90)); }
  }
}

function theme_ads_inner_article($container) {
  try {
    if (typeof(googletag) !== "undefined" && googletag) {
      var mapping = googletag.sizeMapping().
      addSize([0, 0], [[300, 250], [320, 50], [320, 100], [1, 1]]).
      addSize([740, 100], [[300, 250], [336, 280], [1, 1]]).
      build();
      if (!jQuery.isArray(window.theme_www_post_main_center)) { window.theme_www_post_main_center = []; }
      var id_banner = "div-gpt-ad-" + alphanumeric_unique();
      window.theme_www_post_main_center[id_banner] =
        googletag.defineSlot('/20804042/theme_www_post_main_center', [[300, 250], [320, 50], [320, 100], [1, 1]], id_banner).
        defineSizeMapping(mapping).
        addService(googletag.pubads()).
        setCollapseEmptyDiv(true);

      $container.html("<div id='" + id_banner + "'>" +
        "<script type='text/javascript'>" +
        "googletag.cmd.push(function() { " +
          "googletag.display('" + id_banner + "'); " +
          "googletag.pubads().refresh([window.theme_www_post_main_center['" + id_banner + "']]); " +
        "});" +
        "</script>" +
        "</div>");
    } else {
      if(isFunction(setADS)) { $container.html(setADS("INNER ARTICLE JS",300,250)); }
    }
  } catch (err) {
    if(isFunction(setADS)) { $container.html(setADS("INNER ARTICLE JS",300,250)); }
  }
}

function theme_ads_add_ligatus($container) {
  try {
    if (typeof(googletag) !== "undefined" && googletag) {
      var id_banner = "div-gpt-ad-" + alphanumeric_unique();
      console.log('Add banner ligatus ' + id_banner+'======>');

      if ($themeBody.find('#ligatus_thebarbacom_smartbox').length > 0) {
        $themeBody.find('#ligatus_thebarbacom_smartbox').attr('id', 'ligatus_thebarbacom_smartbox_' + id_banner);
      }
      // $container.html("<div id='" + id_banner + "'>" +
      //   "<div id='ligatus_thebarbacom_smartbox'></div>" +
      //   "<script language='javascript' src='http://i.ligatus.com/it-placements/containers/thebarba/tc-site.js' async></script>" +
      //   "</div>");
    }
  } catch (err) {}
}


function theme_ads_premium_native($container) {
 console.log('premium_native');
 console.log($container);
 try {
   if (typeof(googletag) !== "undefined" && googletag) {
     if (!jQuery.isArray(window.theme_gptShareThrough)) { window.theme_gptShareThrough = []; }
     var id_banner = "div-gpt-ad-" + alphanumeric_unique();
     window.theme_gptShareThrough[id_banner] =
      googletag.defineSlot('/7288/thebarba/native_interne', [4, 1], id_banner).
      addService(googletag.pubads()).setTargeting("strnativekey", "ym8F3tPqPk7EJHkAFijspGxZ").
      setCollapseEmptyDiv(true);

     $container.html("<div id='" + id_banner + "'>" +
      "<script type='text/javascript'>" +
      "googletag.cmd.push(function() { " +
        "googletag.display('" + id_banner + "'); " +
        "googletag.pubads().refresh([window.theme_gptShareThrough['" + id_banner + "']]); " +
      "});" +
      "</script>" +
      "</div>");
   }
 } catch (err) {
   console.log(err);
 }
}

/* ================================
===    FUNCTION SINGLE         ====
=================================== */

function add_ads_theme_single($add_post_view_inner_article,$ligatus_container_post_view){
  jQuery.each($add_post_view_inner_article, function(i, item) {
    theme_ads_inner_article(jQuery(this));
    jQuery(this).removeClass('add');
  });
  if($ligatus_container_post_view){
    theme_ads_add_ligatus($ligatus_container_post_view);
  }
}